import { render, staticRenderFns } from "./tiktok_campaign_prize.vue?vue&type=template&id=4952ba82"
import script from "./tiktok_campaign_prize.vue?vue&type=script&lang=ts"
export * from "./tiktok_campaign_prize.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports